module.exports = __webpack_public_path__ + "img/4-2.33ec645b.png";